import React, { useLayoutEffect } from 'react';

import { setUploadLimits, type UploadLimits } from './uploadLimits';

export interface UploadLimitsProviderProps {
    /** The configured limits, or `null` while unknown (sites keep their constants). */
    limits: UploadLimits | null;
    children?: React.ReactNode;
}

/**
 * EAA-1212: publishes the app's configured upload limits to every shared upload site.
 * Layout effect, so a limit fetched before first paint is in place before any child
 * input can be used; on unmount the seam falls back to the sites' own constants.
 */
export function UploadLimitsProvider({ limits, children }: UploadLimitsProviderProps) {
    useLayoutEffect(() => {
        setUploadLimits(limits);
    }, [limits]);
    useLayoutEffect(() => () => setUploadLimits(null), []);
    return <>{children}</>;
}
